import { useNavigate } from "react-router-dom";
import * as Css from "./style";
// import IconeQuestion from "@zendeskgarden/svg-icons/src/16/question-mark-stroke.svg?react";
import { Button } from "@zendeskgarden/react-buttons";
import CardBigNumber from "./cardBigNumber";
import { useBulkHistory } from "../../../hook/useBookHistory";
import { useBuildBulkSummary } from "../../../hook/useBuildBulkSummary";


export default function HeaderHome() {
    const navigate = useNavigate();

    // sem filtros → histórico completo (vem do cache)
    const { data: records = [] } = useBulkHistory({});
    const summary = useBuildBulkSummary(records);

    return (
        <Css.ContainerHeader>
            <Css.ContainerTitle>
                <h1>Bulk Ops</h1>

                <Css.ContainerButtons>
                    {/* <button
                        className="btntutotial"
                        title="Tutorial"
                    >
                        <IconeQuestion color="#4256C8" />
                    </button> */}

                    <Button onClick={() => navigate("/tickets/create")}>
                        Criação massiva
                    </Button>

                    <Button onClick={() => navigate("/tickets/edit")}>
                        Edição massiva
                    </Button>
                </Css.ContainerButtons>
            </Css.ContainerTitle>

            <Css.ContainerBigNumbers>
                <CardBigNumber
                    title="Total de operações"
                    quant={summary.totalSuccess}
                />
                <CardBigNumber
                    title="Operações com Tickets"
                    quant={summary.tickets}
                />
                <CardBigNumber
                    title="Operações com Usuários"
                    quant={summary.users}
                />
                <CardBigNumber
                    title="Operações com Organizações"
                    quant={summary.organizations}
                />
            </Css.ContainerBigNumbers>
        </Css.ContainerHeader>
    );
}
